import { COOKIE_GROUPS } from './constants';

export function getActiveCookieGroups (): string[] {
    const activeIDs: string | undefined = window.OnetrustActiveGroups;

    if (!activeIDs) {
        return [];
    }

    const idList: string = activeIDs.replace(/(^,)|(,$)|\s/g, '');

    return idList.split(',');
}

export function cookiesPermitted (cookieGroup: COOKIE_GROUPS): boolean {
    const activeCookieGroups: string[] = getActiveCookieGroups();

    return activeCookieGroups.includes(cookieGroup);
}
